export const BLACK_FRIDAY_ID = 2;
export const CHRISTMAS_SALE_ID = 3;
export const DAILY_DEALS_ID = 4;
export const CYBER_MONDAY_ID = 6;
export const BLACK_FRIDAY_WEEKEND_ID = 7;
export const BACK_TO_SCHOOL_ID = 9;
export const JANUARY_SALE_ID = 12;
